import { OrderDirection } from "common/contracts/order-direction";
import PaginationParameters from "common/contracts/pagination-parameters";

export class NetworkedGroupFilterParameters {
  public query?: string;
  public name?: string;
  public description?: string;
  public minCreatedDate?: Date;
  public maxCreatedDate?: Date;

  constructor(
    name?: string,
    description?: string,
    minCreatedDate?: Date,
    maxCreatedDate?: Date
  ) {
    this.name = name;
    this.description = description;
    this.minCreatedDate = minCreatedDate;
    this.maxCreatedDate = maxCreatedDate;
  }

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.query) searchParams.append("query", this.query);
    if (this.name) searchParams.append("name", this.name);
    if (this.description) searchParams.append("description", this.description);
    if (this.minCreatedDate) searchParams.append("minCreatedDate", this.minCreatedDate.toISOString());
    if (this.maxCreatedDate) searchParams.append("maxCreatedDate", this.maxCreatedDate.toISOString());
    return searchParams;
  }

  public isEqualTo(other: NetworkedGroupFilterParameters): boolean {
    if (!other) return false;
    return this.query === other.query &&
      this.name === other.name &&
      this.description === other.description &&
      this.minCreatedDate?.getTime() === other.minCreatedDate?.getTime() &&
      this.maxCreatedDate?.getTime() === other.maxCreatedDate?.getTime();
  }
}

export enum NetworkedGroupOrderField {
  Name = "Name",
  Description = "Description",
  Created = "Created",
}

export class NetworkedGroupOrderParameters {
  orderBy?: NetworkedGroupOrderField;
  orderDir?: OrderDirection;

  constructor(
    orderBy?: NetworkedGroupOrderField,
    orderDir?: OrderDirection
  ) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public asSearchParams(): URLSearchParams {
    const params = new URLSearchParams();
    if (this.orderBy) params.append("orderBy", this.orderBy);
    if (this.orderDir) params.append("orderDir", this.orderDir);
    return params;
  }

  public isEqualTo(other: NetworkedGroupOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}


export default class NetworkedGroupQuery {
  filterParameters: NetworkedGroupFilterParameters;
  orderParameters: NetworkedGroupOrderParameters;
  paginationParameters: PaginationParameters;

  constructor(
    filterParameters: NetworkedGroupFilterParameters,
    orderParameters: NetworkedGroupOrderParameters,
    paginationParameters: PaginationParameters,
    _query?: string
  ) {
    this.paginationParameters = paginationParameters;
    this.orderParameters = orderParameters;
    this.filterParameters = filterParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.paginationParameters.asSearchParams(),
      ...this.orderParameters.asSearchParams(),
      ...this.filterParameters.asSearchParams()
    ]);
  }

  isEqualTo(other: NetworkedGroupQuery): boolean {
    if (!other) {
      return false;
    }
    return this.filterParameters.isEqualTo((other.filterParameters)) &&
      this.orderParameters.isEqualTo((other.orderParameters)) &&
      this.paginationParameters.isEqualTo((other.paginationParameters));
  }
}
